import { ProFormDateYearRangePicker } from '@ant-design/pro-components'
import type { Dayjs } from 'dayjs'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type DateYearRangePickerFieldProps = React.ComponentProps<typeof ProFormDateYearRangePicker>

type NoUndefinedRangeValueType = [start: Dayjs | null, end: Dayjs | null]

export function DateYearRangePickerField(props: DateYearRangePickerFieldProps) {
  const fieldCtx = useFieldContext<NoUndefinedRangeValueType | null>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<[Dayjs, Dayjs] | undefined>()

  const merged = useMergedFieldProps({ fieldCtx, editable, props })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormDateYearRangePicker
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={{
          ...merged.fieldProps,
          onChange: value => fieldCtx.handleChange(value ?? null),
        }}
      />
    </EditableShell>
  )
}
